export { default as ManageDataPage } from './ManageDataPage';
export * from './privates';
